import { Container, Grid, Stack, Card, Typography, Box } from "@mui/material";
import { useQuery } from "react-query";
import axios from "axios";

import { API_URL } from "Constants";

interface IItem {
  icon: string;
  name: string;
  value: string;
}

export default function Statistics() {
  const { data } = useQuery({
    queryKey: ["statistic"],
    queryFn: (): Promise<IItem[]> => axios.get(`${API_URL}/statistic`).then((res) => res.data),
  });

  if (!data) return <></>;
  return (
    <Container maxWidth="lg">
      <Grid container columnSpacing={5} rowGap={4}>
        {data.map((item) => (
          <Grid item xs={12} md={6}>
            <Card sx={{ p: 1.5 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" alignItems="center" spacing={2} sx={{ pl: 2 }}>
                  <img src={item.icon} style={{ height: "40px", width: "40px" }} />
                  <Typography>{item.name}</Typography>
                </Stack>

                <Box sx={{ py: 1.5, px: 1, minWidth: "100px", bgcolor: "#eee", borderRadius: "10px" }}>
                  <Typography fontFamily="sans-serif" align="center" fontWeight={700}>
                    {item.value}
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
